module["exports"] = ["Nova", "Velha", "Grande", "Vila", "Município de"];